import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiPaths } from '@gah-core/constants/api-paths.enum';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GAHAppResponse } from '@data/schema/gah-app-response';
import { TranslateService } from '@ngx-translate/core';
import { UserStoreService } from '@gah-core/services/user-store.service';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private userStore: UserStoreService
  ) {}

  private readonly _footerLinks = new BehaviorSubject<any>(null);
  readonly footerLinks$ = this._footerLinks.asObservable();

  getFooterLinks() {
    this.http.get<any>(`${environment.apiUrl}${ApiPaths.FetchFooterLinks}`).subscribe({
      next: (res) => {
        this._footerLinks.next(res);
      },
      error: this.handleError,
    });
  }

  getSocialMediaLinks(): Observable<any> | null {
    let params = new HttpParams().set(
      'territoryId',
      this.userStore.userState.selectedTerritory?.territoryId
    );
    return this.http
      .get<any>(`${environment.apiUrl}${ApiPaths.FetchSocialMediaLinks}`, { params })
      .pipe(
        map((res: GAHAppResponse) => {
          return res.serviceResult;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMsg: {
      message: string;
      errorCode: number;
    } = {
      message: error.error.errorDescription
        ? error.error.errorDescription
        : this.translate.instant('unknown-error-msg-text'),
      errorCode: error.status,
    };
    return throwError(errorMsg);
  }
}
